import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatToolbarModule, MatButtonModule, MatIconModule, MatDialogModule, MatSelectModule, MatInputModule, MatCheckboxModule, MatExpansionModule, MatTableModule, MatRadioModule, MatTooltipModule, MatSidenavModule } from '@angular/material';

import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';

import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainlayoutComponent } from './layouts/mainlayout/mainlayout.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DefaultComponent } from './default/default.component';
import { CountrymapComponent } from './countrymap/countrymap.component';
import { ReportviewComponent } from './reportview/reportview.component';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ProgrammeComponent } from './programme/programme.component';
import { ModulesComponent } from './modules/modules.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { PersonalinfoComponent } from './personalinfo/personalinfo.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SidenavigationComponent } from './navigations/sidenavigation/sidenavigation.component';
import { TopnavigationComponent } from './navigations/topnavigation/topnavigation.component';
import { BcrumbsnavComponent } from './navigations/bcrumbsnav/bcrumbsnav.component';
import { DisclaimercontentComponent } from './disclaimer/disclaimercontent/disclaimercontent.component';
import { DisclaimerprintComponent } from './disclaimer/disclaimerprint/disclaimerprint.component';
import { DisclaimerpageComponent } from './disclaimer/disclaimerpage/disclaimerpage.component';
import { AuthGuardService } from './guards/auth-guard.service';
import { EqualityvalidatorDirective } from './validators/equalityvalidator.directive';
import { DisclaimercontentoverseesComponent } from './disclaimer/disclaimercontentoversees/disclaimercontentoversees.component';
import { ErrorpageComponent } from './errorpage/errorpage.component';
import { QuotationsService } from './services/quotations.service';
import { of, Observable, ObservableInput } from '../../node_modules/rxjs';
import { map, catchError } from 'rxjs/operators';

@NgModule({
  declarations: [
    AppComponent,
    MainlayoutComponent,
    DefaultComponent,
    CountrymapComponent,
    ReportviewComponent,
    ProgrammeComponent,
    ModulesComponent,
    ConfirmationComponent,
    PersonalinfoComponent,
    SidenavigationComponent,
    TopnavigationComponent,
    BcrumbsnavComponent,
    DisclaimercontentComponent,
    DisclaimerprintComponent,
    DisclaimerpageComponent,
    EqualityvalidatorDirective,
    DisclaimercontentoverseesComponent,
    ErrorpageComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatSelectModule,
    MatInputModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatTableModule,
    MatRadioModule,
    MatTooltipModule,
    MatSidenavModule,
    AngularFontAwesomeModule,
    SnotifyModule
  ],
  entryComponents: [
    CountrymapComponent
  ],
  providers: [
    AuthGuardService,
    {provide: 'SnotifyToastConfig', useValue: ToastDefaults },
    SnotifyService,
    {provide: APP_INITIALIZER, useFactory: load, multi: true, deps: [HttpClient, QuotationsService]}
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }

export function load(http: HttpClient, service: QuotationsService): (() => Promise<boolean>) {
  return (): Promise<boolean> => {
    return new Promise<boolean>((resolve: (a: boolean) => void): void => {
       http.get('assets/config/config.json')
         .pipe(
           map((x: QuotationsService) => {
            service.apiurl = x.apiurl;
             resolve(true);
           }),
           catchError((x: { status: number }, caught: Observable<void>): ObservableInput<{}> => {
             if (x.status !== 404) {
               resolve(false);
             }
             service.apiurl = '';
             resolve(true);
             return of({});
           })
         ).subscribe();
    });
  };
}